import { baseApi } from '../baseApi';

export const authApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    loginOwner: builder.mutation<any, any>({
      query: (credentials) => ({
        url: '/auth/login-owner',
        method: 'POST',
        body: credentials,
      }),
    }),
    registerOwner: builder.mutation<any, any>({
      query: (data) => ({
        url: '/auth/register-owner',
        method: 'POST',
        body: data,
      }),
    }),
    getMe: builder.query<any, void>({
      query: () => '/auth/me',
    }),
  }),
  overrideExisting: false,
});

export const { useLoginOwnerMutation, useRegisterOwnerMutation, useGetMeQuery } = authApi;
